import React, { useRef } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  IconButton,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import { useGameContext } from "../../../context/gameContext/gameContext";
import { useNavigate } from "react-router-dom";

import { HamburgerIcon } from "@chakra-ui/icons";
import { useAppContext } from "../../../context/appContext/appContext";

const TableHamburger = ({ setIsGameOver }) => {
  const { notGS } = useAppContext();
  const { resetGameSettings } = useGameContext();

  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  const exitGame = () => {
    notGS();
    resetGameSettings();
    navigate("/play");
  };

  return (
    <Flex className="tableHamburger">
      <IconButton
        ref={btnRef}
        onClick={onOpen}
        icon={<HamburgerIcon />}
        color="headline.400"
        background="white"
      />

      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />

            <DrawerBody mt={"50px"} align="center">
              {/* Add your menu items here */}
              <Button onClick={exitGame}>Exit To Game Menu</Button>
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </Flex>
  );
};
export default TableHamburger;
